<template>
<div class="entry-page">
  <div class="loading-text">加载中...</div>
</div>
</template>

<script>
import h5LoginMixin from './loginMixin';

export default {
  name: 'SubsidiaryEntry',
  mixins: [h5LoginMixin],
  data() {
    return {
      dataty: '',
    };
  },
  created() {
    this.dataty = this.$route.query.dataty || '已送货未开票';
  },
  methods: {
    onLoginSuccess() {
      const isSubsidiaryLeader = sessionStorage.getItem('IS_SUBSIDIARY_LEADER') === 'true';
      if (isSubsidiaryLeader && this.dataty === '已送货未开票') {
        this.$router.replace({
          path: '/RMS/H5/subsidiaryOrderList',
          query: { dataty: this.dataty },
        });
      } else {
        const type = this.dataty === '已送货未开票' ? '1' : '2';
        window.location.href = window.location.origin + '/RMS/H5/list?type=' + type;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.entry-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F5F6F7;
  .loading-text {
    font-size: 14px;
    color: #999;
  }
}
</style>
